import { render } from "./PaymentRegisterDataImport.vue?vue&type=template&id=f80fba24&scoped=true"
import script from "./PaymentRegisterDataImport.vue?vue&type=script&lang=js"
export * from "./PaymentRegisterDataImport.vue?vue&type=script&lang=js"

import "./PaymentRegisterDataImport.vue?vue&type=style&index=0&id=f80fba24&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80fba24"]])

export default __exports__